import { useEffect } from "react";

function isEditableTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) return false;
    const tag = target.tagName;
    return (
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        target.isContentEditable
    );
}

export interface UseUndoRedoKeyboardOptions {
    undo: () => void;
    redo: () => void;
    enabled?: boolean;
}

/** Window-level Ctrl+Z / Ctrl+Y when not typing in a form control. */
export function useUndoRedoKeyboard({
    undo,
    redo,
    enabled = true,
}: UseUndoRedoKeyboardOptions): void {
    useEffect(() => {
        if (!enabled) return;

        const handler = (e: KeyboardEvent) => {
            if (isEditableTarget(e.target)) return;

            if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key.toLowerCase() === "z") {
                e.preventDefault();
                undo();
            } else if (
                ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "y") ||
                ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === "z")
            ) {
                e.preventDefault();
                redo();
            }
        };

        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [undo, redo, enabled]);
}
